import { loadProgressBar } from 'axios-progress-bar';
import 'css/custom-nprogress.css';

const config = {
  showSpinner: false,
};

loadProgressBar(config);
